import { AxiosError } from 'axios';

export const isConflictError = (error: unknown): boolean =>
  (error as AxiosError | undefined)?.response?.status === 409;

export const RETAKE_UNAVAILABLE_MESSAGE =
  "A retake isn't available for this role yet. Please try again later.";
